import React, { useContext } from "react";
import { Row, Col, Button, Space, Tag } from "antd";
import TableContext from "../tableContext";
import { IoIosRefresh } from "react-icons/io";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { exportExcel } from "@HELPERS";

import SearchBox from "./searchbox";

import "../index.scss";

const TableHeader = () => {
  const { props, mutate, loading, name, searchKeys, excelColumns, dataSource } =
    useContext(TableContext);

  return (
    <div className="table-header">
      {searchKeys && searchKeys.length > 0 && (
        <Row gutter={24}>
          <Col flex="none">
            <h2>{name}</h2>
          </Col>
        </Row>
      )}

      <Row gutter={24}>
        {searchKeys && searchKeys.length > 0 ? (
          <Col flex="auto">
            <SearchBox />
          </Col>
        ) : (
          name && (
            <Col flex="auto">
              {props.size === "small" ? <h3>{name}</h3> : <h2>{name}</h2>}
            </Col>
          )
        )}
        {props.tag && (
          <Space>
            <Tag color={"yellow"} style={{ borderRadius: 8, fontSize: 14 }}>
              <div style={{ margin: 5 }}>{props.tag}</div>
            </Tag>
          </Space>
        )}

        <Col flex="none">
          <div className="actions">
            {typeof props.mutate === "function" && (
              <Button
                size={props.size || "big"}
                icon={<IoIosRefresh />}
                disabled={loading}
                onClick={() => mutate()}
              >
                Yenile
              </Button>
            )}
            {excelColumns?.length > 0 && (
              <Button
                className="btn-download"
                size={props.size || "big"}
                icon={<AiOutlineCloudDownload />}
                disabled={loading}
                onClick={() => exportExcel(name, excelColumns, dataSource)}
              >
                İndir
              </Button>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default TableHeader;
